import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISpecialDayList } from '../../../Pages/Pricing/IPricing';

interface IUpdate extends IReduxState<ISpecialDayList> {
  updateableDates?: ISpecialDayList;
}

export const UpdateSpecialDaySlicer = createSlice({
  name: 'UpdateSpecialDay',
  initialState: {
    data: {},
    isLoading: false,
    updateableDates: {},
  } as IUpdate,
  reducers: {
    updateSpecialDay: (state, _) => {
      state.isLoading = true;
    },
    successUpdateSpecialDay: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateSpecialDay: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    SpecialDaysUpdateableData: (state, action) => {
      state.updateableDates = action.payload;
    },
    clearUpdateSpecialDayState: (state) => {
      state.data = {};
      state.updateableDates = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDates = undefined;
    },
  },
});

export const {
  updateSpecialDay,
  failureUpdateSpecialDay,
  successUpdateSpecialDay,
  SpecialDaysUpdateableData,
  clearUpdateSpecialDayState,
  clearUpdateableData,
} = UpdateSpecialDaySlicer.actions;

export default UpdateSpecialDaySlicer.reducer;
